// <s-review-gate> opens the Judge.me "write a review" form (photo + text, or text only)
// for logged-in customers. Guests never reach this: Liquid renders a login link for them.
// After login, the return URL carries ?review=write so the form opens automatically.
class SReviewGate extends HTMLElement {
  #ac;
  #timer = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', (event) => {
      if (event.command === '--write') this.#open();
    }, { signal: this.#ac.signal });

    const params = new URLSearchParams(window.location.search);
    if (params.get('review') === 'write') this.#open();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.#timer);
  }

  #open(attempt = 0) {
    clearTimeout(this.#timer);
    const widget = this.querySelector('[data-review-widget]');
    const link = widget?.querySelector('.jdgm-write-rev-link');
    const unavailable = this.querySelector('[data-review-unavailable]');

    if (link) {
      if (unavailable) unavailable.hidden = true;
      const form = widget.querySelector('.jdgm-form-wrapper');
      const isOpen = form && form.offsetParent !== null;
      if (!isOpen) link.click();
      widget.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      return;
    }

    // Judge.me loads asynchronously; wait up to ~8s before showing the fallback message.
    if (attempt < 16) {
      this.#timer = setTimeout(() => this.#open(attempt + 1), 500);
    } else if (unavailable) {
      unavailable.hidden = false;
    }
  }
}

if (!customElements.get('s-review-gate')) customElements.define('s-review-gate', SReviewGate);
